<template>
  <div
    class="card cursor"
    :class="{ 'en-font': lang === 'ENG' }"
    :style="cardStyle"
    @mouseenter="$emit('mouseenter')"
    @mouseleave="$emit('mouseleave')"
  >
    <div class="card-content">
      <h3 class="card-title">{{ title }}</h3>
      <p class="card-description" v-html="formattedDescription"></p>

      <transition name="fade">
        <div v-if="showLinks" class="skinc-card-links">
          <a
            v-for="(link, index) in links"
            :key="index"
            :href="applyLanguageQuery(link.url)"
            rel="noopener noreferrer"
            class="skinc-card-link"
          >
            <span class="link-text">{{ link.text }}</span>
            <img src="/static_img/skinc/road/arrow_right_white.svg" class="link-icon" alt="arrow" />
          </a>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardComponent',
  props: {
    title: String,
    description: String,
    background: String,
    links: Array,
    isHovered: Boolean,
    isOtherHovered: Boolean,
    lang: { type: String, default: 'KOR' }
  },
  data: function () {
    return {
      showLinks: false,
      linkRenderTimer: null
    };
  },
  computed: {
    formattedDescription() {
      return this.description.replace(/\n/g, '<br>');
    },
    cardStyle() {
      const verticalPadding = 'clamp(20px, 5vw, 60px)';
      const horizontalPadding = this.isOtherHovered
        ? 'clamp(10px, 2.5vw, 30px)'
        : 'clamp(20px, 5vw, 60px)';

      return {
        backgroundImage: `url(${this.background})`,
        flex: this.isHovered ? '3 0 0' : '1 0 0',
        paddingTop: verticalPadding,
        paddingBottom: verticalPadding,
        paddingLeft: horizontalPadding,
        paddingRight: '0px',
        transition: 'flex 0.5s ease, padding-left 0.5s ease',
        zIndex: this.isHovered ? 10 : 1
      };
    }
  },
  watch: {
    isHovered: function (newValue) {
      clearTimeout(this.linkRenderTimer);
      if (newValue) {
        this.linkRenderTimer = setTimeout(() => {
          this.showLinks = true;
        }, 500);
      } else {
        this.showLinks = false;
      }
    }
  },
  methods: {
    applyLanguageQuery(originalUrl) {
      if (this.lang !== 'ENG' || !originalUrl) {
        return originalUrl;
      }

      try {
        if (originalUrl.startsWith('#')) {
          const url = new URL(window.location.href);
          url.searchParams.set('l', 'ENG');
          url.hash = originalUrl;
          return url.href;
        }
        const url = new URL(originalUrl);
        url.searchParams.set('l', 'ENG');
        return url.href;
      } catch (e) {
        console.error('Invalid URL provided:', originalUrl);
        return originalUrl;
      }
    }
  }
};
</script>

<style scoped>
.card {
  position: relative;
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
  box-sizing: border-box;
  overflow: visible;
  border-radius: 0;
  min-width: 0;
}

.card-content {
  position: relative;
  z-index: inherit;
  text-align: start;
  color: white;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card-title {
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  font-size: clamp(29px, 4.8vw, 53px);
  text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
}

.card-description {
  line-height: 1.5;
  margin: 0;
  white-space: nowrap;
  font-size: clamp(18px, 3vw, 24px);
  text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
}

.skinc-card-links {
  display: flex;
  flex-wrap: wrap;
  gap: clamp(16px, 1.5vw, 24px);
}

.skinc-card-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid white;
  border-radius: 100px;
  color: white;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 0.5s;
  min-width: 100px;
  padding: clamp(4px, 1vw, 8px) clamp(8px, 2vw, 12px);
  font-size: clamp(14px, 2.4vw, 19px);
  text-shadow: 0px 2px 5px rgba(0, 0, 0, 0.3);
}

.skinc-card-link:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.link-icon {
  width: 20px;
  height: 20px;
  margin-left: 4px;
}

.card.en-font .card-title {
  font-size: clamp(23.2px, 3.84vw, 42.4px);
}
.card.en-font .card-description {
  font-size: clamp(14.4px, 2.4vw, 19.2px);
}
.card.en-font .skinc-card-link {
  font-size: clamp(11.2px, 1.92vw, 15.2px);
}

.fade-enter-active {
  transition: opacity 0.3s ease;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
